import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { matchPasswordValidator } from '../../../shared/validators/match-password.validator';
import { customValidator } from 'src/app/shared/validators/custom-validator.validators';
import { AuthenticationService } from '../../../shared/store/authentication/authentication.service';

@UntilDestroy()
@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.scss'],
    host: { class: 'connection-form p-4 col-12 col-sm-8' },
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  showErrorLogin: any;
  resetPasswordForm: FormGroup;
  paramsSubscription$: Subscription;
  email: string | undefined;
  token: string | undefined;
  msgError: string;
  css: string = 'alert-danger';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly authenticationService: AuthenticationService,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
  ) {}

  ngOnInit(): void {
    this.resetPasswordForm = this.formBuilder.group({
      password: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          customValidator(/\d/),
          customValidator(/[A-Z]/),
          customValidator(/[a-z]/),
        ],
      ],
      passwordConfirm: [
        '',
        [
          Validators.required,
          Validators.minLength(6),
          customValidator(/\d/),
          customValidator(/[A-Z]/),
          customValidator(/[a-z]/),
        ],
      ],
    });

    this.resetPasswordForm.setValidators(matchPasswordValidator);
    this.resetPasswordForm.updateValueAndValidity();

    this.email = this.route.snapshot.queryParams['email'];
    this.token = this.route.snapshot.queryParams['token'];

    if (this.email == undefined || this.token == undefined) {
      this.msgError = 'LOGIN_LBL_RESET_PASSWORD_PASSWORD_ERROR';
      this.showErrorLogin = true;
      this.css = 'alert-danger';
    }
  }

  onSubmit() {
    this.showErrorLogin = false;
    if (this.resetPasswordForm.invalid) {
      this.resetPasswordForm.markAllAsTouched();
      this.msgError = 'LOGIN_LBL_RESET_PASSWORD_PASSWORD_ERROR_FORM';
      this.showErrorLogin = true;
      return;
    }

    if (this.email == undefined) return;
    if (this.token == undefined) return;

    let result$ = this.authenticationService.resetPassword.call({
      email: this.email,
      token: this.token.split(' ').join('+'), //usefull because '+' are ' ' and throw 'invalid token'
      password: this.resetPasswordForm.value.password!,
    });

    result$
      .pipe(
        // catchError(e => { return e }),
        filter((x) => x !== undefined),
        untilDestroyed(this),
      )
      .subscribe({
        next: (result) => {
          if (result) {
            this.css = 'alert-success';
            this.msgError = 'LOGIN_LBL_RESET_PASSWORD_PASSWORD_SUCCESS';
            this.showErrorLogin = true;
            this.resetPasswordForm.reset();

            console.log('password reset');

            this.router.navigate(['/']);
          } else {
            this.css = 'alert-danger';
            this.msgError = 'LOGIN_LBL_RESET_PASSWORD_PASSWORD_FAIL';
            this.showErrorLogin = true;
          }
        },
        error: () => {
          this.css = 'alert-danger';
          this.msgError = 'LOGIN_LBL_RESET_PASSWORD_PASSWORD_FAIL';
          this.showErrorLogin = true;
        },
      });
  }
}
